import IPAccordion from './IPAccordion'

export default IPAccordion
